import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { ApplicationsService } from './../../applications/applications.service';
import { ConnectionDB } from './../../interfaces/connectionDb';
import { ConfigurationDbModalService } from './configuration-db-modal.service';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/list';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'mic-app-configuration-db-modal',
  templateUrl: './configuration-db-modal.component.html',
  styleUrls: ['./configuration-db-modal.component.scss'],
  imports: [MatDialogTitle, MatIcon, MatDivider, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatDialogActions, MatButton]
})
export class ConfigurationDbModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ConfigurationDbModalComponent>>(MatDialogRef);
  configurtionService = inject(ConfigurationDbModalService);
  private readonly applicationsService = inject(ApplicationsService);
  data = inject<ConnectionDB>(MAT_DIALOG_DATA);

  connectionForm: FormGroup;
  hide = true;

  /***************************************************👌
   * This function initializes the connection form.   *
   * @return {void}                                   *
   ***************************************************/
  ngOnInit(): void {
    this.connectionForm = new FormGroup({
      name: new FormControl(this.data?.name, Validators.required),
      url: new FormControl(this.data?.url, Validators.required),
      username: new FormControl(this.data?.username, Validators.required),
      password: new FormControl(this.data?.password, Validators.required)
    });
  }

  /*****************************************************************************************************************************************👌
   * This function updates the connection if data is not null, otherwise it adds a new connection.                                          *
   * @param {ConnectionDB} this.connectionForm.value - The value of the connection to update or to add based on the value of the data       *
   * @returns {void}                                                                                                                        *
   ******************************************************************************************************************************************/
  onSubmit() {
    if (this.data !== null) {
      this.configurtionService.updateConnection(this.data.id, this.connectionForm.value).subscribe(() => {
        this.onClose(true);
      });
    } else {
      this.configurtionService.addConnection(this.applicationsService.myObject.id, this.connectionForm.value).subscribe(() => {
        this.onClose(true);
      });
    }
  }

  /***********************************👌
   * This function closes the dialog. *
   * @return {void}                   *
   ************************************/
  onNoClick(): void {
    this.dialogRef.close();
  }
  onClose(alert: boolean) {
    this.dialogRef.close(alert);
  }
}
